<app-multi-select-with-static-options
  [formControl]="control"
  [label]="label"
  [name]="name"
  [selectOptions]="selectOptions"
  [multi]="false"
  [placeholder]="placeholder"
></app-multi-select-with-static-options>
